// New-month rule for in-progress setups: repeating things keep their calendar
// month and roll on; one-time things in the month(s) that ended are dropped and listed.
const LONG = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export function monthsBetween(fromIso, toIso) {
  const [fy, fm] = fromIso.split("-").map(Number);
  const [ty, tm] = toIso.split("-").map(Number);
  return (ty - fy) * 12 + (tm - fm);
}

export function monthLabel(startIso, index) {
  const [y, m] = startIso.split("-").map(Number);
  const t = m - 1 + index;
  return `${LONG[((t % 12) + 12) % 12]} ${y + Math.floor(t / 12)}`;
}

const mod12 = (n) => ((n % 12) + 12) % 12;
const rotate = (arr, shift) =>
  Array.isArray(arr) && arr.length === 12 ? arr.map((_, i) => arr[mod12(i + shift)]) : arr;
const remapIdx = (list, shift) =>
  Array.isArray(list) ? [...new Set(list.map((k) => mod12(Number(k) - shift)))].sort((a, b) => a - b) : list;

function rollRepeating(item, shift) {
  return {
    ...item,
    anchor_month_index: item.anchor_month_index == null ? item.anchor_month_index : mod12(Number(item.anchor_month_index) - shift),
    months_active: remapIdx(item.months_active, shift),
    monthly_amounts: rotate(item.monthly_amounts, shift),
  };
}

export function rollForward(inputs, fromIso, toIso) {
  const shift = monthsBetween(fromIso, toIso);
  if (shift <= 0) return { inputs, dropped: [] };
  const dropped = [];

  const one_off_costs = (inputs.one_off_costs || []).filter((c) => {
    const n = Number(c.month_index) || 0;
    if (n - shift >= 0) return true;
    if (c.name) dropped.push(`${c.name} (${monthLabel(fromIso, n)})`);
    return false;
  }).map((c) => ({ ...c, month_index: (Number(c.month_index) || 0) - shift }));

  const revenue_streams = (inputs.revenue_streams || []).map((r) => {
    const out = rollRepeating({ ...r, monthly_sales: rotate(r.monthly_sales, shift) }, shift);
    if (r.is_future) {
      const n = (Number(r.launch_month_index) || 0) - shift;
      if (n <= 0) {
        if (r.name) dropped.push(`${r.name} launch (${monthLabel(fromIso, Number(r.launch_month_index) || 0)})`);
        return { ...out, is_future: false, launch_month_index: 0 };
      }
      return { ...out, launch_month_index: n };
    }
    return out;
  });

  const goals = (inputs.goals || []).map((g) => {
    if (g.target_month_index === "" || g.target_month_index == null) return g;
    const n = Number(g.target_month_index) - shift;
    if (n >= 1) return { ...g, target_month_index: n };
    if (g.title) dropped.push(`${g.title} deadline (${monthLabel(fromIso, Number(g.target_month_index) - 1)})`);
    return { ...g, target_month_index: "" };
  });

  return {
    inputs: {
      ...inputs,
      start_month: toIso,
      recurring_costs: (inputs.recurring_costs || []).map((c) => rollRepeating(c, shift)),
      one_off_costs,
      revenue_streams,
      goals,
    },
    dropped,
  };
}
